import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import Header from "./Navigation/Header";
import Footer from "./Footer/Footer";

const Layout = ({
  children,
  headerStyle,
  headerLinkColor,
  headerHasBorder,
  headerDarkMode,
  hideHeader,
  hideFooter,
}) => {
  return (
    <div>
      <Helmet>
        <script src="https://app.termly.io/resource-blocker/75019c2c-b848-42ac-b192-772e9d934dd4?autoBlock=on"></script>
        {/* <script
          type="text/javascript"
          src="https://www.bugherd.com/sidebarv2.js?apikey=rlixevldoxvjxoaddjxhiw"
          async="true"
        ></script> */}
        {/* <script type="text/javascript">
          {(function (k, s) {
            if (typeof window !== "undefined") {
              s = document.createElement("script");
              s.defer = true;
              s.src = "https://cdn.feedbucket.app/assets/feedbucket.js";
              s.dataset.feedbucket = k;
              document.head.appendChild(s);
            }
          })("ue401loImRCONBACo5IG")}
        </script>
        <script type="text/javascript">
          {`
          if(typeof window !== "undefined"){
            if(window.self !== window.top || ~location.href.indexOf("wv_task=")){
              var s = document.createElement("script");
              s.type = "text/javascript";
              s.src = "https://app.webvizio.com/js/webvizio.js";
              s.id = "webvizio_script";
              document.head.append(s);
              }
          }
        `}
        </script> */}
      </Helmet>
      <Header
        headerStyle={headerStyle}
        headerLinkColor={headerLinkColor}
        headerHasBorder={headerHasBorder}
        headerDarkMode={headerDarkMode}
        hideHeader={hideHeader}
      />
      <main id="body-content" className="bg-[#26272B]">
        {children}
      </main>
      <Footer hideFooter={hideFooter} />
    </div>
  );
};

Layout.propTypes = {
  headerStyle: PropTypes.string,
  headerLinkColor: PropTypes.string,
  headerHasBorder: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Layout;
